<template>
  <div>
    <back-btn />

    <v-row>
      <v-col lg="10" offset-lg="1">
        <visit-data-view></visit-data-view>
      </v-col>
    </v-row>
    <end-dots-form></end-dots-form>
  </div>
</template>

<script>
import VisitDataView from "@/components/dots/VisitDataView.vue";
import EndDotsForm from "@/components/dots/UseApp/EndDotsForm.vue";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    "visit-data-view": VisitDataView,
    BackBtn,
    EndDotsForm,
  },
};
</script>

<style></style>
